import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { Dealer, OrderLineDetail } from 'app/core/model/entity-model';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-report-warranties',
    templateUrl: './report-warranties.component.html',
    styleUrls: ['./report-warranties.component.scss'],
    standalone: false
})
export class ReportWarrantiesComponent implements OnInit {
    orderLineDetails: any[];
    dealers: Dealer[];
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private modalService: BsModalService, public auth: AuthService, private appInfo: AppInformationService,) {}

    async ngOnInit() {
        this.dealers = (await this.uow.dealers.all()) as Dealer[];
        this.filter = {};
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.orderLineDetails = await this.uow.getWarrantiesForReport(this.filter);
        console.log(this.filter);
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.filter = {};
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            // {
            //     location: 'before',
            //     template: 'toolbarButtons',
            // },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        if (!orderId) return;
        const modalRef = this.modalService.show(OrderDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                orderId: orderId,
                showAsDialog: true,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.salesOrderId) return;
        await this.open(e.data.salesOrderId);
    }
}
